<template>
  <!-------------------- END - Controles arriba de tabla-------------------->
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Unidad Medida</th>
          <th scope="col" class="">Barra</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="det in data" v-bind:key="det.id" v-if="det.estatus">
          <td scope="row">
            {{ det.unidad_medida_obj.nombre }}
          </td>
          <td>{{ det.barra }}</td>
          <td class="text-right">
            <button
              type="button"
              class="btn btn-sm btn-danger"
              @click="eliminarBarra(det)"
            >
              Eliminar
            </button>
          </td>
        </tr>
        <tr>
          <td>
            <UnidadMedidaSelectComponent :current="current" />
          </td>
          <td>
            <div class="form-group">
              <label>Barra</label>
              <input
                id="demo"
                v-on:keyup.enter="agregarBarra"
                v-model="current.barra"
                class="form-control"
                placeholder="Barra"
                type="text"
                v-bind:class="{
                  'is-invalid':
                    current.errors.barra && current.errors.barra.length > 0,
                }"
              />
              <small
                v-if="current.errors && current.errors.barra"
                class="form-text text-danger"
                >{{ current.errors.barra }}</small
              >
            </div>
          </td>
          <td class="text-right">
            <button
              type="button"
              class="btn btn-sm btn-success"
              @click="agregarBarra"
            >
              Agregar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import ProductoBarraService from "@/services/catalogos/ProductoBarraService";
import ProductosService from "@/services/catalogos/ProductosService";
import UnidadMedidaSelectComponent from "@/components/commons/UnidadMedidaSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";


export default {
  components: {
    PaginationComponent,
    UnidadMedidaSelectComponent,
  },
  data() {
    return {
      data: [],
      unidades_medidas: [],
      current: {
        unidad_medida: 0,
        barra: "",
        errors: {
          unidad_medida: "",
        },
      },
    };
  },
  props: ["sku"],
  mounted() {
    let self = this;
    self.refreshData();
  },
  methods: {
    agregarBarra() {
      let self = this;
      if (self.current.barra == null || self.current.barra == "") {
        alert("Barra requerida");
        return;
      }

      let params = {
        unidad_medida: self.current.unidad_medida,
        barra: self.current.barra,
      };
      ProductosService.agregar_barra(self.sku,params)
        .then((res) => {
          self.refreshData();
          self.current.unidad_medida = 0;
          self.current.barra = "";
        })
        .catch((error) => {
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
            Notifications.alert.error("Error", self.current.errors.non_field_errors);
          });
        });
    },
    eliminarBarra(barra) {
      let self = this;
      if (!confirm("¿Desea eliminar la barra?")) {
        return;
      }
      DynamicService.postAction(
        "cat",
        "producto-barra",
        barra.id,
        "eliminar_barra",
        {
          sku: self.sku,
          barra: barra.barra,
        }
      ).then((response) => {
        Notifications.alert.success(
          "Eliminar barra de producto",
          "Realizado exitosamente"
        );
        self.refreshData();
        self.current.unidad_medida = 0;
        self.current.barra = "";
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({});
    },
    filterData() {
      this.refreshData({});
    },
    clearFilterData() {
      this.refreshData({});
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      self.current.errors ={};
      params = {
        producto: self.sku,
        quitar_paginacion: "true",
      };
      ProductoBarraService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      /*let self = this;
      self.$router.push({
        name: "cat-centro-costos-editar",
        params: { id: current.id },
      });*/
    },
    showModalEdit() {},
  },
};
</script>
